import { w as withConfigTransport } from "../../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _VaFileUploadGalleryItem } from "./VaFileUploadGalleryItem-6af99e92.mjs";
const VaFileUploadGalleryItem = withConfigTransport(_VaFileUploadGalleryItem);
export {
  VaFileUploadGalleryItem as V
};
//# sourceMappingURL=index-2c0719bc.mjs.map
